import React from 'react';
import { motion } from 'framer-motion';

export const STAGES = [
  { key: 'understanding', label: 'Understanding' },
  { key: 'exploring', label: 'Exploring' },
  { key: 'prototyping', label: 'Prototyping' },
];

function statusFor(currentStage, stageKey) {
  const currentIndex = STAGES.findIndex((s) => s.key === currentStage);
  const stageIndex = STAGES.findIndex((s) => s.key === stageKey);
  if (stageIndex < currentIndex) return 'completed';
  if (stageIndex === currentIndex) return 'active';
  return 'pending';
}

export default function ProgressBar({ currentStage = 'understanding' }) {
  return (
    <div
      className="progress-bar"
      role="progressbar"
      aria-label="Discovery progress"
      data-testid="progress-bar"
    >
      {STAGES.map((stage, idx) => {
        const status = statusFor(currentStage, stage.key);
        return (
          <React.Fragment key={stage.key}>
            <motion.div
              className={`progress-step progress-step-${status}`}
              data-testid={`progress-step-${stage.key}`}
              data-status={status}
              initial={false}
              animate={{ opacity: status === 'pending' ? 0.6 : 1 }}
              transition={{ duration: 0.3 }}
            >
              <span className="progress-step-dot" aria-hidden="true" />
              <span className="progress-step-label">{stage.label}</span>
            </motion.div>
            {idx < STAGES.length - 1 && (
              <span
                className={
                  status === 'completed'
                    ? 'progress-connector progress-connector-completed'
                    : 'progress-connector'
                }
                data-testid={`progress-connector-${idx}`}
                aria-hidden="true"
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
